import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Types and Action Creators
 */
const { Types, Creators } = createActions({
    navigate: ['step'],
    navigateForward: null,
    navigateBackward: null,
});

export const NavigationTypes = Types;
export default Creators;

/**
 * Initial State
 */
export const INITIAL_STATE = Immutable({
    active: global.standaloneScene || 1,
    backwardNavigation: false,
    forwardNavigation: true,
    items: [
        {
            id: 0,
            name: 'series',
        },
        {
            id: 1,
            name: 'basicModel',
        },
        {
            id: 2,
            name: 'engine',
        },
        {
            id: 3,
            name: 'paintwork',
        },
        {
            id: 4,
            name: 'package',
        },
        {
            id: 5,
            name: 'interior',
        },
        {
            id: 6,
            name: 'basicVehicle',
        },
        {
            id: 7,
            name: 'optionalEquipment',
        },
        {
            id: 8,
            name: 'conclusion',
        },
    ],
});

const MINIMAL_STEP = 1;

const LAST_STEP = 8;

/**
 * Navigate to step
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const navigate = (state, action) => {
    if (action.step < MINIMAL_STEP || action.step > LAST_STEP) {
        return state;
    }
    const newState = {};
    newState.active = action.step;

    newState.forwardNavigation = action.step !== LAST_STEP;
    newState.backwardNavigation = action.step !== MINIMAL_STEP;

    return state.merge(newState);
};

/**
* Navigate to next step
*
* @param {Object} state
* @param {Object} action
* @return {Object}
*/
export const navigateForward = (state) => navigate(state, { step: state.active + 1 });

/**
 * Navigate to previous step
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const navigateBackward = (state) => navigate(state, { step: state.active - 1 });

/**
 *  Hookup Reducers To Types
 */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.NAVIGATE]: navigate,
    [Types.NAVIGATE_FORWARD]: navigateForward,
    [Types.NAVIGATE_BACKWARD]: navigateBackward,
});
